import { render } from "./TileGameQuestion.vue?vue&type=template&id=9de441c2"
import script from "./TileGameQuestion.vue?vue&type=script&lang=js"
export * from "./TileGameQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__